import type { AddLineItemType } from "@/Shared/Types/lineItemTypes";

export function isDangerous(lineItems: Array<AddLineItemType>) {
  return lineItems.some((lineItem) => lineItem.isDangerous);
}
